import React, {useState} from 'react'

import { useNavigate } from 'react-router-dom';


import TitleChnage from "../Hook/TitleChnage";

import imageOne from "../resource/arama/F20 (2).png";
import imageOtwo from "../resource/arama/F20.png";
import imageThree from "../resource/arama/F21.png";
import imageFour from "../resource/arama/L25.png";
import imageFive from "../resource/arama/L26.png";
import imageSix from "../resource/arama/L27.png";
import imageSeven from "../resource/arama/L28.png"
import imageNine from "../resource/arama/F19.png";

import '../css/common.css'

const Arama = () => {

    TitleChnage("Arama Pooja")

    const navigate = useNavigate();

    const [isTextVisible,setIsTextVisible] = useState(false);

    const handleToggle = () => {
        setIsTextVisible((prev) => !prev);
    }

    const handleClick = (event) => {

    const pathMap = {
      annualarma:"/annualarma",
      ceramonyvideo : "/ceramonyvideo",
      selectDay : "/selectDay",
      securespot:"/securespot"
      }

      const path = event.currentTarget.id;
      const targetPath = pathMap[path]

      if (targetPath) {
          navigate(targetPath)
      }
  }

  return (
    <div className="page arama-page">
    <img src={imageOne} alt="" className="left-imge" />
    <img src={imageOtwo} alt="" className="right-imge" />

    <header>
      <div className="home-icon">{/* <img src="#" alt="Home Icon"> */}</div>
      <div className="title">
        <h1>Arama Pooja</h1>
        <img src={imageThree} width={300} />
      </div>
    </header>

    <section className="intro-text">
      <p className='text-bold'>The wise rejoice in giving, gain happiness in the 
        life hereafter
      </p>
      <p className="meditate-info text-black">
        Arama Pooja - Arama Pooja is a significant ceremony 
        in the Buddhist tradition, where land is offered to 
        Buddha Sasana for the establishment of a residence 
        for Sangha. This event holds spiritual and communal importance 
        as the community gain merits and practitioners find space for theri spiritual journey....           <span className='lowertext curser-pointer' onClick={handleToggle}>{isTextVisible ? "" : "more"}</span>

      </p>

      {isTextVisible &&
                <div className="hidden-text">
                <p className="dana-info text-black">Offering a piece of land for an Arama is typically not feasible for an individual. However, when the land is divided into small plots, it becomes affordable for many devotees. These devotees can then purchase a $ 500 worthy land plot and offer it to the Arama, with their contributions recorded in a "Sannaspathra" deed. Collectively, these individual contributions form the entire land of the Arama.</p>
                <p className="dana-info text-black">Bhaddeka Vihari Forest Monastery and retreat centre, situated in Ripplebrook, in the countryside of Victoria, Australia, was established in 2017 on a 42-acre property that previously functioned as a luxury motel. The Melbourne Buddhist community, fervent in their desire to create a dedicated space for practitioners devoted to the Buddha Sasana, made significant financial contributions accumulated up to 6 million to support the acquisition of this land. Despite their collective efforts, the funds raised were insufficient to cover the total cost of 2 million, necessitating a $1.4 million bank loan in 2017 to complete the purchase.</p>
                <p className="dana-info text-black">Contributing to a residence for practitioners is a noble meritorious cause. Whether you are a practitioner today, might become one tomorrow, or paving the way for your children to become practitioners, or simply gaining the joy from your gift, you will undoubtedly benefit in one way or another. Therefore, you are cordially invited to secure your title to the remaining 1,400 "Sannaspathra" and participate in this meritorious act. 
          <span className='lowertext curser-pointer' onClick={handleToggle}>{isTextVisible ? "less" : ""}</span>

                </p>
                </div>
                }
    </section>

    <section className="button-section">
      <div className="left-col">
        <img src={imageFour} alt="" width={300} id='annualarma' onClick={handleClick}/>
        <img src={imageFive} alt="" width={300} id='selectDay' onClick={handleClick}/>
        
      </div>
      <div className="right-col">
      <img src={imageSix} alt="" width={300} id='securespot' onClick={handleClick}/>
      <img src={imageSeven} alt="" width={300} id='ceramonyvideo' onClick={handleClick}/>
      </div>
    </section>

    <div className="box">
      <img src={imageNine} alt="" className="bottom-imge" />
    </div>
  </div>
  )
}

export default Arama
